import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const migrateTeamToSupportV2 = {
  name: "migrateTeamToSupportV2" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ workflowId: z.string() }),
};
